// extracted by mini-css-extract-plugin
module.exports = {"root":"LazyImage_root__3RWgp","image":"LazyImage_image__3Y-bB","visible":"LazyImage_visible__30kip"};